import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import BarbaApp from './barba/BarbaApp';
import AutoplayVideos from './components/AutoplayVideos';
import Header from './components/Header';

export class Airport {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Airport.domReady()]).then(() => this.init());
	}

	init() {
		new BarbaApp();
		new AutoplayVideos();

		const headerElm = document.querySelector('[data-header]');
		if (headerElm) {
			new Header(headerElm);
		}
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Airport();